import { Link } from 'react-router-dom';

type props = {
	href: string;
	description: string;
};

function LegalLink({ href, description }: props) {
	return (
		<Link to={href} className="text-purpleBrand-500 font-bold">
			{description}
		</Link>
	);
}

export default LegalLink;
